import React from 'react'
import { SGWhatsnewCard,SGWhatsnew, MainWhatsnew, WhatsnewButtonWrapper, SGWhatsnewCardWrapper } from '../../styles/whatsnew.styled'
import {BsFillArrowRightCircleFill} from "react-icons/bs";
const SGWhatnew = () => {
  return (
    <MainWhatsnew>
     <SGWhatsnew>
      <div>
        <h1>Blink & Miss: Upcoming Events You Should Book Now!</h1>
        <text>
        Catch some of the most action-packed events – all at your favourite island city! Check out upcoming events here.
        </text>
      </div>
      <SGWhatsnewCardWrapper>
      <SGWhatsnewCard>
       <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1653379073_jcr_content_renderimage_carousel_rect_265_149.jpg"></img>
       <h3>Dragon Boat Festival</h3>
       <h5>3RD JUNE 2022</h5>
      </SGWhatsnewCard>
      <SGWhatsnewCard>
       <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1653379191_jcr_content_renderimage_carousel_rect_265_149_1.jpg"></img>
       <h3>Hari Raya Haji</h3>
       <h5>10TH JULY 2022</h5>
      </SGWhatsnewCard>
      <SGWhatsnewCard>
       <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1653379358_shutterstock_1163432560_min.jpg"></img>
       <h3>Hungry Ghost Festival</h3>
       <h5>12TH AUGUST 2022</h5>
      </SGWhatsnewCard>
      <SGWhatsnewCard>
       <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1653379878_screenshot_2022_05_24_at_1_40_13_pm.jpg"></img>
       <h3>World Gourmet Summit</h3>
       <h5>17TH – 23RD AUGUST 2022</h5>
      </SGWhatsnewCard>
      </SGWhatsnewCardWrapper>
      
    <WhatsnewButtonWrapper>
     <img src="https://cdn1.tripoto.com/media/filter/nxxl/img/1789711/Image/1612791126_web_cta.jpg"></img>
    </WhatsnewButtonWrapper>
    </SGWhatsnew>

    <SGWhatsnew>
<div>
  <h1>What’s New and Marvellous in Singapore</h1>
  <text>
  Singapore is so much more than its skyscrapers. Explore Singapore’s most marvellous attractions that will add delight to your travel experience.
  </text>
</div>
<SGWhatsnewCardWrapper>
<SGWhatsnewCard>
 <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1643355460_container_13_1.jpg"></img>
 <h3>Visit The Delightful Museum Of Ice Cream</h3>

</SGWhatsnewCard>
<SGWhatsnewCard>
 <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1643355480_container_13_2.jpg"></img>
 <h3>Witness Exotic Flora And Fauna At The Newest Kingfisher Wetlands In Gardens By The Bay</h3>

</SGWhatsnewCard>
<SGWhatsnewCard>
 <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1643355491_container_13_3.jpg"></img>
 <h3>Raise A Toast At The World’s Highest Microbrewery In Singapore</h3>

</SGWhatsnewCard>
<SGWhatsnewCard>
 <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1643355500_container_13_4.jpg"></img>
 <h3>Enjoy A Delectable Lunch At Hortus, Enveloped In The Flower Dome, Gardens By The Bay</h3>

</SGWhatsnewCard>
</SGWhatsnewCardWrapper>

<WhatsnewButtonWrapper>
<img src="https://cdn1.tripoto.com/media/filter/nxxl/img/1789711/Image/1610972019_web_exp_more_1.jpg"></img>
</WhatsnewButtonWrapper>

</SGWhatsnew>

<SGWhatsnew>
<div>
  <h1> Take a Look Back at The Most 'Singapore-Ful' Moments of 2021</h1>
  <text>
A look back on a wonderful year of meaningful and exciting events where despite travel restrictions, we brought the flavors and spirit of Singapore to you, dear travellers, who we missed so much!
  </text>
</div>
<SGWhatsnewCardWrapper>
<SGWhatsnewCard>
 <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1643355187_container_9_1.jpg"></img>
 <h3>We Experienced Singapore’s Modernity And Biodiversity Through The Eyes Of NatGeo Explorers</h3>

</SGWhatsnewCard>
<SGWhatsnewCard>
 <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1643355199_container_9_2.jpg"></img>
 <h3>We Brought Singapore Home With The ‘Spirit Of Singapore’ Infusion Kit</h3>

</SGWhatsnewCard>
<SGWhatsnewCard>
 <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1643355210_container_9_3.jpg"></img>
 <h3>Several Travellers Shared Their Beloved Memories Of Singapore To The Tunes Of Khoye Se</h3>

</SGWhatsnewCard>
<SGWhatsnewCard>
 <img src="https://cdn1.tripoto.com/media/filter/tst/img/1745358/Image/1643355221_container_9_4.jpg"></img>
 <h3>With The Indian Edition Of SFF, Foodies Discovered Singapore’s Culinary Delights</h3>

</SGWhatsnewCard>
</SGWhatsnewCardWrapper>
</SGWhatsnew>

    </MainWhatsnew>
    
  )
}

export default SGWhatnew



{/*  */}